// removed by extract-text-webpack-plugin
module.exports = {"title-modal":"app-components-LibraryDeleteModal-__style___1NWgA","dialog":"app-components-LibraryDeleteModal-__style___2CT7A","header-delete":"app-components-LibraryDeleteModal-__style___7FIEj"};


//////////////////
// WEBPACK FOOTER
// ./app/components/LibraryDeleteModal/style.css
// module id = 1975
// module chunks = 0